import api from './api'
const root='/api/workforce/replacements'
export const replacementService={
 async list(){return (await api.get(root)).data.requests||[]},
 async create(assignmentId:string,reason:string,idempotencyKey:string){return (await api.post(root,{assignmentId,reason,idempotencyKey})).data.request},
 async candidates(id:string){return (await api.get(`${root}/${id}/candidates`)).data.candidates||[]},
 async act(row:any,action:string,extra:Record<string,unknown>={}){return (await api.post(`${root}/${row.id}/actions`,{revision:row.revision,action,...extra})).data.request},
}
